module.exports = __webpack_public_path__ + "img/sr.788f3e2a.svg";